import React from 'react';
import cn from './../../../../lib/bem';
import { useNavigate } from 'react-router-dom';
import img_padre from './../../../../assets/svg/img_padre.svg';
import ButtonComponent from './../../../../components/button/button_component';

import './seccion_banner.scss';

const SeccionBanner = () => {
  const classes = cn('seccionBanner');
  const history = useNavigate();

  return (
    <div className={classes()}>
      <div className={classes('seccionBannerDiv')}>
        <div>
          <br />
          <p className={classes('seccionBannerSubTitleSBS')}>
            Código SBS: VI2007100144
          </p>
          <p className={classes('seccionBannerTitleFirst')}>
            <b>Simula tu seguro</b>
          </p>
          <p className={classes('seccionBannerTitle')}>
            <b>Fondo Vida Garantizado</b>
          </p>
          <p className={classes('seccionBannerSubTitle')}>
            Protege a tus seres queridos invirtiendo a plazo fijo con retorno
            garantizado.
          </p>
          <div className={classes('seccionBannerButton')}>
            <ButtonComponent
              type="button"
              label={'btn-simulador'}
              tipo={'button-red'}
              disabled={false}
              action={() => history('/datosPersonales')}
              nombre={'Realizar una simulación'}
            />
          </div>
          <br />
        </div>
        <div className={classes('seccionBannerImg')}>
          <img src={img_padre} alt="Padre con su hijo" />
        </div>
      </div>
    </div>
  );
};

export default SeccionBanner;
